
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/onestepcheckout",
      function () {
        return require("private-next-pages/onestepcheckout/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/onestepcheckout"])
      });
    }
  